// ----------------------------------------------------------------------

export default function Button(theme) {
  return {
    MuiButton: {
      styleOverrides: {
            root: {
              height: 34, 
              '&:hover': {
                  backgroundColor: 'inherit', // keep the same as default
                  boxShadow: 'none',          // remove any hover shadow
              },

        },
        sizeLarge: {
          height: 48,
        },
            containedInherit: {
                backgroundColor: '#E9EEFF',   // your chosen background
                color: theme.palette.grey[800],
                boxShadow: 'none',
                '&:hover': {
                    backgroundColor: '#E9EEFF', // lock same bg
                    boxShadow: 'none',
                },
            },

            containedPrimary: {
                backgroundColor: '#2e7d32',
                // boxShadow: theme.customShadows.primary,
                boxShadow: 'none',
                '&:hover': {
                    backgroundColor: '#2e7d32', // keep same
                    boxShadow: 'none',
                },
        },
            containedSecondary: {
                backgroundColor: theme.palette.secondary.main, // keep default bg
                color: theme.palette.secondary.contrastText,   // ensure text color stays visible
                boxShadow: 'none',
                '&:hover': {
                    backgroundColor: theme.palette.secondary.main, // don't change on hover
                    boxShadow: 'none',
                },
            },

        outlinedInherit: {
          border: `1px solid ${theme.palette.grey[500_32]}`,
            '&:hover': {
                backgroundColor: 'transparent', // no hover background
                borderWidth: '1px',   
            },
            },
            outlined: {
                borderWidth: '1px', // for all outlined buttons
                '&:hover': {
                    borderWidth: '1px', // prevent 2px border on hover
                },
            },
        textInherit: {
            '&:hover': {
                backgroundColor: 'transparent', // no hover background
            },
        },
      },
    },
  };
}
